module.exports = __webpack_public_path__ + "Simple-Line-Icons.0bbfc705e37a927ce2ae.woff";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.woff?-i3a2kk
// module id = ../../../../../src/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.woff?-i3a2kk
// module chunks = styles